<template>
  <div class="wordDict absolute z-10 border borderRed cursor-default scrollBar shadow-md" v-if="content" :class="{ 'dict_chat': isRightSide }">
    <div class="content relative">
      <div class="flex items-center mb-1">
        <a @click.stop="PlayAudioDict()" class="cursor-pointer bg-red-main-ai flex items-center justify-center playerBtn mr-2">
          <i class="fas fa-volume-up text-sm text-white"></i>
        </a>
        <h5 class="font-bold text-xl mb-0">{{ content.key }}</h5>
      </div>
      <div class="translation_KK flex flex-wrap">
        <span class="translation_KK_type ml-2">{{ content.phon }}</span>
      </div>
      <p class="translation_KK_expl whitespace-pre-line" v-if="content.expl">{{ content.expl }}</p>
      <!-- 關聯字 -->
      <div v-if="content.linkKeys.length > 0" class="mt-2">
        <div v-for="(el,idx) in subDictInfo" :key="idx">
          <audio :id="'subAudioPlayer'+ idx" :src="`${BaseUrl}/livelibrary/Dict/Word/${el.key}/audio?lang=en`" controls="controls" :ref="'subAudioPlayer' + idx"></audio>
          <div class="flex items-center mb-1">
            <a @click.stop="PlaySubAudioDict(idx)" class="cursor-pointer bg-red-main-ai flex items-center justify-center playerBtn mr-2">
              <i class="fas fa-volume-up text-sm text-white"></i>
            </a>
            <h5 class="font-bold text-xl mb-0">{{ el.key }}</h5>

          </div>
          <div class="translation_KK flex flex-wrap">
            <span class="translation_KK_type ml-2">{{ el.phon }}</span>
          </div>
          <p class="translation_KK_expl whitespace-pre-line" v-if="el.expl">{{ el.expl }}</p>
        </div>
      </div>
      <!-- 關聯字 -->
      <a class="cursor-pointer absolute closeBtn block" @click.prevent.stop="closeDict()">
        <img src="@/assets/image/ai/closeBtn.png" alt="" class="inline-block">
      </a>
    </div>
    <audio v-if="content.key" muted id='audio' :src="`${BaseUrl}/livelibrary/Dict/Word/${content.key}/audio?lang=en`" controls="controls" ref="audioplayer"></audio>
  </div>
</template>

<script>
import dictApi from '@/dictApi'
  export default {
    name: 'WordDict',

    data () {
      return {
        subDictInfo: []
      }
    },
    props: {
      content: {
        type: Object
      },
      isRightSide: {
        type: Boolean
      }
    },
    computed: {
      BaseUrl () {
        if (process.env.NODE_ENV === 'production') {
          return 'https://api.liveabc.com/v1'
        } else {
          return 'https://apitest.liveabc.com/v1'
        }
      }
    },
    mounted () {
      this.PlayAudioDict()
      this.content.linkKeys.length > 0 ? this.getSubDicts() : null
    },
    methods: {
      closeDict () {
        let self = this
        self.$emit('closeDict')
      },
      async openSubDictionary (el) {
        let self = this
        if(self.subDictInfo !== null) {
          self.subDictInfo = null
        } else {
          self.store.commit('isLoading', true)
          const { data } = await dictApi.get(`/v1/livelibrary/Dict/Word/${el}`)
          self.subDictInfo = data.
          self.store.commit('isLoading', false)
        }
      },
      PlayAudioDict () {
        let self = this
        if (self.$refs.audioplayer) {
          let audioplayer = self.$refs.audioplayer
          // 判斷是否播放中
          audioplayer.onplaying = () => {
            self.isPlaying = true
          }
          audioplayer.onpause = () => {
            self.isPlaying = false
          }
          // 播放切換
          if (self.isPlaying) {
            audioplayer.pause()
            audioplayer.currentTime = 0
            self.isPlaying = false
          } else {
            audioplayer.play()
            self.isPlaying = true
          }
        }
      },
      PlaySubAudioDict (idx) {
        let self = this
        if (self.$refs['subAudioPlayer' + idx]) {
          let subAudioplayer = self.$refs['subAudioPlayer' + idx][0]
          // 判斷是否播放中
          subAudioplayer.onplaying = () => {
            self.isPlaying = true
          }
          subAudioplayer.onpause = () => {
            self.isPlaying = false
          }
          // 播放切換
          if (self.isPlaying) {
            subAudioplayer.pause()
            subAudioplayer.currentTime = 0
            self.isPlaying = false
          } else {
            subAudioplayer.play()
            self.isPlaying = true
          }
        }
      },
      async getSubDicts () {
        let self = this
        for (let value of self.content.linkKeys) {
          const { data } = await dictApi.get(`/v1/livelibrary/Dict/Word/${value}`)
          self.subDictInfo.push(data.data)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.dict_chat {
  left: auto !important;
  right: 0 !important;
}
.wordDict {
  width: 22em;
  height: 12em;
  overflow-y: scroll;
  left: 0%;
  top: 100%;
  position: absolute;
  padding-bottom: 1rem;
  padding: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;

  cursor: default;
  border-width: 1px;
  line-height: 2;
  background-color: #F3F3F3;
  box-shadow: 0px 0px 8px 0px #00000080;
  @media (min-width: 768px) {
    display: block;
    z-index: 99;
  }
  .whitespace-pre-line {
    white-space: pre-line;
  }
  .closeBtn {
    top: 0;
    right: 0;
    padding: 0.25rem;
    color: black;
  }
  .playerBtn {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
  }
  .content {
    .translation_KK {
      .translation_KK_spell {
        color: #195BBF;
      }
    }
    .translation_KK_expl {
      font-size: 14px !important;
    }
  }
}

.scrollBar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
}

.scrollBar::-webkit-scrollbar {
  width: 6px;
}

.scrollBar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
</style>
